// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6866":"5b4523b25d7142f6","7823":"c513694f6e69c02a"}[chunkId] + ".js";
};